<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  data-test="feed-advice-detail"
  (backAction)="back()"
>
  <ng-container actions>
    <mat-select
      *ngIf="mode === 'view' && isRearingGiltsFeedAdvice()"
      [hideSingleSelectionIndicator]="true"
      class="flex__child--auto spacing--margin-right text--small headerSelector"
      data-test="printsetting-selector"
      (selectionChange)="setPrintSetting($event)"
      [value]="printSetting"
    >
      <mat-option [value]="'pocketsize'">{{
        'feed-advice-report.report-setting.pocketsize' | translate
      }}</mat-option>
      <mat-option [value]="'fullsize'">{{
        'feed-advice-report.report-setting.fullsize' | translate
      }}</mat-option>
    </mat-select>
    <div class="feed-advice-detail__actions">
      <button
        *ngIf="mode === 'view'"
        mat-flat-button
        color="accent"
        data-test="feed-advice__report-button"
        (click)="printFeedAdvice()"
      >
        <mat-icon>print</mat-icon>
        {{ getButtonText('print') }}
      </button>
      <button
        *ngIf="mode === 'edit'"
        type="submit"
        mat-flat-button
        color="accent"
        (click)="save()"
        data-test="feed-advice__save-button"
      >
        <mat-icon>save</mat-icon>
        {{ getButtonText('save') }}
      </button>
    </div>
  </ng-container>

  <agr-print-page
    class="print-only"
    [footerText]="'feed-advice-title' | translate"
    [customizedLogoSrc]="
      (location$ | async)?.country === 'NL' ? '/assets/images/thinkpig_50.png' : null
    "
    [orientation]="printOrientation"
  >
    <app-feed-advice-report
      *ngIf="printSetting === 'fullsize'"
      [feedAdvice]="feedAdvice$ | async"
      [tableScheme]="tableScheme"
    ></app-feed-advice-report>
  </agr-print-page>

  <div
    class="screen-only spacing--margin-horizontal spacing--margin-top"
    *ngIf="feedAdvice$ | async as feedAdvice"
  >
    <div class="spacing--margin-bottom" *ngIf="mode === 'view' && printSetting === 'fullsize'">
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'create-feed-advice.properties.name' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__name">
            {{ feedAdvice.name }}
          </span>
        </div>
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.date' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__date">
            {{ feedAdvice.updated | agrDate: 'dd-MM-yyyy' }}
          </span>
        </div>
        <div class="flex--column" *ngIf="!isReferenceFeedAdvice">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.advisor' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__advisor-name">
            {{ feedAdvice.advisorName }}
          </span>
        </div>
        <div class="flex--column">
          <ng-container
            *ngIf="
              feedAdvice.geneticLine && (isWeanedPigletFeedadvice() || isRearingGiltsFeedAdvice())
            "
          >
            <span class="text--small text--gray label">
              {{ 'feed-advice-detail.geneticline' | translate }}
            </span>
            <span class="text--small text--bold label" data-test="feed-advice__geneticLine">
              {{ feedAdvice.geneticLine | translate }}
            </span>
          </ng-container>
        </div>
      </div>
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feedAdviceType.label' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ 'feedAdviceType.' + feedAdviceType.toLowerCase() | translate }}
          </span>
        </div>
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.gender' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__genders">
            {{ genders }}
          </span>
        </div>
        <div class="flex--column" *ngIf="!isWeanedPigletFeedadvice()">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.feedintake' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__feedintake">
            {{ feedintake }}
          </span>
        </div>
        <div class="flex--column" *ngIf="isWeanedPigletFeedadvice()">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.weaning-weight' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__weaningWeight">
            {{ weaningWeight }}
          </span>
        </div>
        <div class="flex--column" *ngIf="isWeanedPigletFeedadvice()">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.weaning-age' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__weaningAge">
            {{ weaningAge }}
          </span>
        </div>
      </div>
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.number-of-phases' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__nrOfPhases">
            {{ feedAdvice.numberOfPhases }}
          </span>
        </div>
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.phase-transition' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__phaseTransition">
            {{
              'feed-advice-properties.phaseTransition.' + feedAdvice.phaseTransition.toLowerCase()
                | translate
            }}
          </span>
        </div>
        <div class="flex--column" *ngIf="advice.isGilt">
          <span *ngIf="advice.type === FeedAdviceType.REARING" class="text--small text--gray label">
            {{ 'feed-advice-properties.feeding-type.label' | translate }}
          </span>
          <span
            *ngIf="advice.type === FeedAdviceType.REARING"
            class="text--small text--bold label"
            data-test="feed-advice__feedingType"
          >
            {{
              'feed-advice-properties.feeding-type.' + (advice.feedingType ?? FeedingType.CDI)
                | lowercase
                | translate
            }}
          </span>
        </div>
        <div class="flex--column" *ngIf="!advice.isGilt || isWeanedPigletFeedadvice()">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.terminal-boar' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__terminal-boar">
            {{
              !!feedAdvice.terminalBoar && feedAdvice.terminalBoar.length > 0
                ? feedAdvice.terminalBoar
                : ('feed-advice-detail.terminal-boar-empty' | translate)
            }}
          </span>
        </div>
      </div>
      <div class="spacing--margin-top flex--row flex--nowrap" *ngIf="isRearingGiltsFeedAdvice()">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-properties.rearingAge.label' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__rearingAge">
            {{ feedAdvice.rearingAge }}
          </span>
        </div>
      </div>
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.remarks' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ feedAdvice.description }}
          </span>
        </div>
      </div>
    </div>

    <!-- READONLY POCKETSIZE DOSATOR TABLE-->
    <ng-container *ngIf="mode === 'view' && printSetting === 'pocketsize'">
      <h3>{{ 'sows-feed-advice.table.label-pocketsize' | translate }}</h3>
      <table data-test="pocketsize-table" class="pocketsize-table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th [attr.colspan]="advice?.fatteningRearingFeedAdviceLines[0].consumptions.length">
              {{ 'sows-feed-advice.table.dosator' | translate }}
              {{ 'create-product.phases-label' | translate }}
            </th>
          </tr>
          <tr>
            <th class="align-left">{{ 'scheme-table.weekAge' | translate }}</th>
            <th class="align-left">{{ 'scheme-table.ageRearing' | translate }}</th>
            <ng-container
              *ngFor="
                let consumption of advice?.fatteningRearingFeedAdviceLines[0].consumptions;
                let i = index
              "
            >
              <th class="align-left">{{ 'scheme-table.phase' + (i + 1) | translate }}</th>
            </ng-container>
            <th class="align-left">
              {{ 'scheme-table.dosator_feeding_times' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let line of advice?.fatteningRearingFeedAdviceLines">
            <td>{{ line.weekAge }}</td>
            <td>{{ line.age }}</td>
            <ng-container *ngFor="let consumption of line.consumptions">
              <td class="medium-column">
                {{ consumption.dosatorPosition | agrNumber: '1.0-0' }}
              </td>
            </ng-container>
            <td>{{ line.feedingTimesPerDay }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <ng-container *ngIf="mode === 'edit'">
      <button
        *ngIf="!isReferenceFeedAdvice"
        mat-button
        class="button--text float-right"
        (click)="openPriceSettings()"
        data-test="feed-advice__pricesettings-button"
      >
        <mat-icon class="material-icons-outlined">settings</mat-icon>
        {{ 'price-settings.title' | translate }}
      </button>
      <h3>{{ 'create-feed-advice.properties.name' | translate }}</h3>
      <mat-form-field class="flex__child--auto">
        <input
          matInput
          required
          placeholder="{{ 'create-feed-advice.properties.name' | translate }}"
          data-test="create-feed-advice__feedadvice-name"
          [(ngModel)]="advice.name"
          #name="ngModel"
        />
      </mat-form-field>
      <div *ngIf="name.invalid && (name.dirty || name.touched)" class="validation-error">
        <div *ngIf="name.errors?.['required']">
          {{ 'feed-advice-detail.validation-error.description.feedadvice-name' | translate }}
        </div>
      </div>

      <app-feed-advice-settings
        [isReferenceFeedAdvice]="isReferenceFeedAdvice"
        [properties]="feedAdviceProperties"
        [locations]="advice.locationIds"
        (settingsChanged)="changeFeedAdviceSettings($event)"
      ></app-feed-advice-settings>

      <h3>{{ 'feed-advice-detail.remarks' | translate }}</h3>
      <div class="remarks__container">
        <textarea
          class="text--small remarks__field"
          label="remarks"
          rows="3"
          placeholder="{{ 'create-feed-advice.scheme.remarks-placeholder' | translate }}"
          data-test="feed-advice__remarks"
          [(ngModel)]="advice.description"
        ></textarea>
      </div>
    </ng-container>
    <ng-container class="table-container spacing--margin-top" *ngIf="products$ | async">
      <app-feed-advice-table
        *ngIf="(printSetting === 'fullsize' && mode === 'view') || mode === 'edit'"
        [isEditMode]="mode === 'edit'"
        [showLysineColumn]="showLysine"
        [showEnergyColumn]="showEnergy"
        [showDosatorColumn]="showDosator"
        [feedAdviceType]="feedAdviceType"
        [isReferenceFeedAdvice]="isReferenceFeedAdvice"
        [tableScheme]="tableScheme"
        [products]="products$ | async"
        (updateSummaryTable)="updateSummaryTable()"
        [finalWeight]="finalWeight"
        [feedingType]="advice.feedingType"
      ></app-feed-advice-table>
    </ng-container>
    <div class="table-container spacing-top">
      <ng-container
        *ngIf="
          (mode === 'view' && printSetting === 'fullsize') ||
          (mode === 'edit' && !hasTableValidationErrors)
        "
      >
        <agr-table [config]="productTotalsTableConfig" data-test="product-totals-table">
        </agr-table>
      </ng-container>

      <agr-notification-empty
        [isEmpty]="mode === 'edit' && hasTableValidationErrors"
        [emptyTitle]="'product-totals-table.empty-title' | translate"
        [emptyDescription]="'product-totals-table.empty-description' | translate"
        emptyImage="assets/images/pigs_001.jpg"
      >
      </agr-notification-empty>
    </div>
  </div>

  <!-- READONLY POCKETSIZE DOSATOR TABLE-->
  <ng-container *ngIf="mode === 'view' && printSetting === 'pocketsize'">
    <h3>{{ 'sows-feed-advice.table.label-pocketsize' | translate }}</h3>
    <table data-test="pocketsize-table" class="pocketsize-table">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th [attr.colspan]="advice?.fatteningRearingFeedAdviceLines[0].consumptions.length">
            {{ 'sows-feed-advice.table.dosator' | translate }}
            {{ 'create-product.phases-label' | translate }}
          </th>
        </tr>
        <tr>
          <th class="align-left">{{ 'scheme-table.weekAge' | translate }}</th>
          <th class="align-left">{{ 'scheme-table.ageRearing' | translate }}</th>
          <ng-container
            *ngFor="
              let consumption of advice?.fatteningRearingFeedAdviceLines[0].consumptions;
              let i = index
            "
          >
            <th class="align-left">{{ 'scheme-table.phase' + (i + 1) | translate }}</th>
          </ng-container>
          <th class="align-left">
            {{ 'scheme-table.dosator_feeding_times' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let line of advice?.fatteningRearingFeedAdviceLines">
          <td>{{ line.weekAge }}</td>
          <td>{{ line.age }}</td>
          <ng-container *ngFor="let consumption of line.consumptions">
            <td class="medium-column">
              {{ consumption.dosatorPosition | agrNumber: '1.0-0' }}
            </td>
          </ng-container>
          <td>{{ line.feedingTimesPerDay }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <app-feed-advice-graph
    *ngIf="
      (printSetting === 'fullsize' && mode === 'view') ||
      (mode === 'edit' && !hasTableValidationErrors)
    "
    [lines]="this.tableScheme?.feedAdviceLines"
    [feedAdviceType]="feedAdviceType"
  ></app-feed-advice-graph>
</agr-page-detail>
